<template>
  <div class="">
    <el-row class="xlhrow">
      <div class="xlhbg">
        <div class="szht">
          <img src="/img/images/logo_szht2.png" width="110px" height="28px" />
        </div>
        <div class="xtmc">
          智慧财务网上综合服务平台
        </div>
        <div class="mt-18 bbh">
          <span>{{ version }}</span>
          <span class="bbts">{{ versionts }}</span>
        </div>
        <div class="yxq">
          <span>有效期：</span>
          <span class="yxqms">{{ xlhyxq }}</span>
        </div>
        <div class="xlh">
          <span>序列号：</span>
          <el-input class="xlhinput" size="mini" v-model="xlh"></el-input>
          <el-button class="xlhbnt" size="mini" type="primary" @click="setXlh">
            激活/延期
          </el-button>
        </div>
        <div class="bqsy">版权所有:&nbsp;&copy;&nbsp;{{ bqsy }}</div>
      </div>
    </el-row>
  </div>
</template>

<script>
import * as yhxx from "@/api/yhxx";
import * as login from "@/api/login";
export default {
  name: "xlhsz",
  computed: {},
  data() {
    return {
      xlh: "",
      bqsy: "",
      version: "",
      versionts: "",
      xlhyxq: "",
      xlhkey: "",
    };
  },
  methods: {
    /** 查询参数信息 */
    getXlhsz() {
      login.getXlhsz({ xlhkey: this.$store.state.xlhkey }).then((res) => {
        if (res.data.code == "200") {
          this.xlh = res.data.data.xlh;
          this.bqsy = res.data.data.footbqsy;
          this.version = res.data.data.version;
          this.versionts = res.data.data.versionts;
          this.xlhyxq = res.data.data.xlhyxq;
          this.xlhkey = res.data.data.xlhkey;
        }
      });
    },
    /** 编辑系统参数 */
    setXlh() {
      login.setXlh({ xlhkey: this.xlhkey, xlh: this.xlh }).then((res) => {
        if (res.data.code == "200") {
          this.$message.success(res.data.message);
          if (this.$store.state.pubKey && this.$store.state.pubKey != "") {
            this.getXlhsz();
          }
          this.$emit("closeDialog");
        }
      });
    },
  },
  mounted() {
    this.getXlhsz();
  },
};
</script>
<style lang="scss" scoped>
.xlhrow {
  background-color: #f8fbff;
  width: 680px;
  height: 380px;
  margin: auto;
  padding: 32px 46px;
  background-image: url(/img/xlhbg.png);
  background-position: right top;
  background-repeat: no-repeat;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.xlhbg {
  width: 100%;
  height: 100%;
  // padding: 32px 46px;
}
.szht {
  width: 110px;
  height: 26px;
}
.xtmc {
  // width: 350px;
  height: 31px;
  font-size: 32px;
  font-family: MiSans;
  font-weight: 800;
  color: #333333;
  line-height: 24px;
  margin-top: 30px;
}
.bbh {
  //   width: 66px;
  height: 20px;
  font-size: 20px;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
}
.bbts {
  width: 83px;
  height: 13px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #e37f1f;
  line-height: 24px;
  margin-left: 11px;
}
.yxq {
  width: 380px;
  height: 14px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
  margin-top: 60px;
}
.yxqms {
  //   width: 204px;
  height: 14px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  line-height: 24px;
  margin-left: 19px;
}
.xlh {
  width: 500px;
  height: 14px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
  margin-top: 28px;
}
.xlhinput {
  width: 300px;
  height: 32px;
  margin-left: 19px;
}
.xlhbnt {
  width: 100px;
  height: 32px;
  background: #0d6ce4;
  border-radius: 3px;
  margin-left: 10px;
}
.bqsy {
  width: 237px;
  height: 14px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
  margin-top: 60px;
}
</style>
